import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import { connect, history } from 'umi';
import { Text } from '@digitalc/dxp-ui';
import { RightOutlined } from '@ant-design/icons';
import pointTransfer from '@/assets/images/point/pointTransfer.png';
import pointOrderInco from '@/assets/images/point/pointOrderInco.png';
import pointHistoryInco from '@/assets/images/point/pointHistoryInco.png';
// import { get } from 'lodash';
import { HexToRGB, appUrlJump, numberFormat, onHistoryPush } from '@/utils/utils';
import { sanitizeUrl } from '@/utils/sanitize';
import { trackSensors } from '@/utils/sensors';
import { Clickable } from '@/components';
import styles from './index.less';

function InformationBar({
  visible,
  infoTitle,
  infoTitleUrl,
  hasInfoTitle,
  rightPicture,
  hasCamShow,
  bottomPicture1,
  hasUniversalShow1,
  bottomPicture2,
  hasUniversalShow2,
  infoTitleColor,
  infoTitleColorOpacity,
  pointsColor,
  pointsColorOpacity,
  rightQuickColor,
  rightQuickColorOpacity,
  isRightQuickBg,
  rightQuickBgColor,
  rightQuickBgColorOpacity,
  bottomQuickColor,
  bottomQuickColorOpacity,
  isBottomQuickBg,
  bottomQuickBgColor,
  bottomQuickBgColorOpacity,
  hasBg,
  bgType,
  bgColor,
  bgColorOpacity,
  bgImg,
  topMargin,
  horizontalOutterMargin,
  showChevron = false,
  dispatch,
  isWeb,
  isMulPoints,
  pointAccountsInfo,
  dxpToken,
}) {
  const [points, setPoints] = useState(0);

  // const infoTitleUrl = '/pointshop/pointsTransfer';

  const bgStyle = {
    marginTop: `${Number(topMargin) / 100}rem`,
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    backgroundImage: hasBg === 'Y' && bgType === 'Image' ? `url(${bgImg.src})` : 'initial',
    backgroundSize: '100% 100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    marginLeft: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    marginRight: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    borderRadius: '.08rem',
  };

  const infoStyle = {
    color: HexToRGB(infoTitleColor, infoTitleColorOpacity),
    display: hasInfoTitle ? 'initial' : 'none',
  };

  const pointStyle = {
    color: HexToRGB(pointsColor, pointsColorOpacity),
  };

  const camStyle = {
    color: HexToRGB(rightQuickColor, rightQuickColorOpacity),
    background:
      isRightQuickBg === 'Y'
        ? HexToRGB(rightQuickBgColor, rightQuickBgColorOpacity)
        : 'transparent',
  };

  const uniStyle = {
    color: HexToRGB(bottomQuickColor, bottomQuickColorOpacity),
    background:
      isBottomQuickBg === 'Y'
        ? HexToRGB(bottomQuickBgColor, bottomQuickBgColorOpacity)
        : 'transparent',
  };

  const queryPoints = () => {
    try {
      dispatch({
        type: 'pointShop/getPointDetailDXP',
        payload: {
          scopes: 'LATEST_EXPIRING_POINT',
        },
      }).then(res => {
        if (res) {
          const pointObj = Array.isArray(res)
            ? res?.find(item => item.pointAccountTypeCode === '1')
            : res;
          setPoints(pointObj?.usablePointDisplay || 0);
          // setPoints((Array.isArray(res) ? res?.[0]?.usablePointDisplay : res?.usablePointDisplay) || 0);
        }
      });
    } catch {
      // Point lookup failures leave the current balance unchanged.
    }
  };

  // 点击事件
  const onClickHandler = linkTemp => {
    const initAppStr = window.localStorage.getItem('initApp');
    const initApp = JSON.parse(initAppStr) || {};
    let link = linkTemp;
    if (!link) {
      return;
    }
    if (link.includes('PointExchange')) {
      // log
      trackSensors('reward_home', {
        category: 'reward_home',
        action: 'button_click',
        label: 'data bank',
      });
    }
    if (isWeb && link.includes('/history')) {
      link = link.replace('/history', '/pointsH5/modal/history');
    }
    if (isWeb && link.includes('/myVoucher')) {
      link = link.replace('/myVoucher', '/pointsH5/modal/myVoucher');
    }
    if (isWeb && link.includes('/order')) {
      link = link.replace('/order', '/pointsH5/modal/order');
    }
    if (isWeb && link.includes('/PointExchange')) {
      link = link.replace('/PointExchange', '/pointshop/pointsH5/modal/PointExchange');
    }
    if (link.includes('http')) {
      // window.open(link, '_self');
      link = `${link}&needGoBack=true`;
      if (window?.clp) {
        link = `${link}&needGoBackByApp=true`;
        setTimeout(() => {
          appUrlJump(link);
        }, 100);
      } else {
        const { token, currentAccNbr, prefix } = history.location.query;
        // return;
        setTimeout(() => {
          const safeUrl = sanitizeUrl(
            `${link}&token=${token || initApp?.token}&currentAccNbr=${
              currentAccNbr || initApp?.phone
            }&prefix=${prefix || initApp?.prefix}`,
          );
          if (safeUrl) {
            window.location.href = safeUrl;
          }
        }, 100);
      }
    } else {
      // console.log('zzzzzzzzzz', link);
      // history.push(link);
      onHistoryPush(link);
    }
  };

  useEffect(() => {
    queryPoints();

    // 挂载到 window
    window.onPageVisible = () => {
      // 只有在积分商城首页才刷新积分，其它页面不刷新
      if (window.location.pathname.includes('pointshop/pointsH5')) {
        queryPoints();
      }
    };

    // 组件卸载时清理
    return () => {
      delete window.onPageVisible;
    };
  }, []);

  const handleGoToConversion = () => history.push('/pointshop/pointsTransfer');

  const onlyPointAcctType = (
    <div
      className={cl(styles.builderBox, {
        hidden: !visible,
      })}
      style={bgStyle}
    >
      {hasCamShow && (
        <Clickable
          className={styles.pointsRightBox}
          style={camStyle}
          onClick={() => onClickHandler(rightPicture[0]?.link || '')}
        >
          {rightPicture[0].src && rightPicture[0].src.includes('http') && (
            <img src={rightPicture[0].src} alt="" />
          )}
          <div className={styles.title}>{rightPicture[0].iconName}</div>
        </Clickable>
      )}
      <div className={styles.pointsBox}>
        <div className={styles.pointsName} style={infoStyle}>
          {infoTitle}
        </div>
        <div className={styles.numWrap}>
          <Clickable
            as="span"
            className={styles.num}
            style={pointStyle}
            onClick={() => onClickHandler(infoTitleUrl)}
          >
            {numberFormat(points)}
            {/* {infoTitleUrl.includes('pointsTransfer') ? <img src={pointTransfer} alt="" /> : <RightOutlined />} */}
            {showChevron && <RightOutlined />}
          </Clickable>
        </div>
        <div className={styles.bottomBox}>
          {hasUniversalShow1 && (
            <Clickable
              className={styles.picList}
              style={uniStyle}
              onClick={() => onClickHandler(bottomPicture1[0]?.link || '')}
            >
              {bottomPicture1[0].src && bottomPicture1[0].src.includes('http') && (
                <img src={bottomPicture1[0].src} alt="" />
              )}
              <div className={styles.name}>{bottomPicture1[0].iconName}</div>
            </Clickable>
          )}
          {hasUniversalShow2 && (
            <Clickable
              className={styles.picList}
              style={uniStyle}
              onClick={() => onClickHandler(bottomPicture2[0]?.link || '')}
            >
              {bottomPicture2[0].src && bottomPicture2[0].src.includes('http') && (
                <img src={bottomPicture2[0].src} alt="" />
              )}
              <div className={styles.name}>{bottomPicture2[0].iconName}</div>
            </Clickable>
          )}
        </div>
      </div>
    </div>
  );

  const pointsAcctTypeRender = (
    <div className={styles.pointAccountsInfoWrap}>
      <div style={bgStyle} className={styles.bgContent}>
        {pointAccountsInfo.map(item => (
          <div
            key={item.pointAccountTypeCode}
            className={styles.pointAcctWrap}
            style={{ backgroundColor: HexToRGB(dxpToken.colorBackgroundDark2, 30) }}
          >
            <div className={styles.pointName} style={{ color: dxpToken.colorTextInverse }}>
              <Text breakpoint="Mobile" size="ContentC12Regular">
                {item.pointAccountTypeName}
              </Text>
            </div>
            <div className={styles.pointAcctValueWrap} style={{ color: dxpToken.colorTextInverse }}>
              <Text breakpoint="Mobile" size="TitleT21Bold">
                {numberFormat(item.usablePointDisplay)}
              </Text>
              <Clickable
                as="img"
                src={pointTransfer}
                onClick={handleGoToConversion}
                style={{ marginLeft: '0.1rem' }}
                alt=""
              />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.quickAction}>
        <Text breakpoint="Mobile" size="ContentC14Bold">
          Quick Action
        </Text>
      </div>

      <div className={styles.actionWrap}>
        <Clickable
          className={styles.actionItem}
          style={{ backgroundColor: dxpToken.colorBackgroundStandard }}
          onClick={() => history.push('/pointshop/history')}
        >
          <img src={pointHistoryInco} alt="" />
          <Text breakpoint="Mobile" size="ContentC12Bold">
            Point History
          </Text>
        </Clickable>
        <Clickable
          className={styles.actionItem}
          style={{ backgroundColor: dxpToken.colorBackgroundStandard }}
          onClick={() => history.push('/pointshop/order')}
        >
          <img src={pointOrderInco} alt="" />
          <Text breakpoint="Mobile" size="ContentC12Bold">
            My Order
          </Text>
        </Clickable>
      </div>
    </div>
  );

  return isMulPoints && pointAccountsInfo?.length > 1 ? pointsAcctTypeRender : onlyPointAcctType;
}

InformationBar.propTypes = {
  visible: PropTypes.bool,
  infoTitle: PropTypes.string,
  infoTitleUrl: PropTypes.string,
  hasInfoTitle: PropTypes.bool,
  rightPicture: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      link: PropTypes.string,
      iconName: PropTypes.string,
    }),
  ),
  hasCamShow: PropTypes.bool,
  bottomPicture1: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      link: PropTypes.string,
      iconName: PropTypes.string,
    }),
  ),
  hasUniversalShow1: PropTypes.bool,
  bottomPicture2: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      link: PropTypes.string,
      iconName: PropTypes.string,
    }),
  ),
  hasUniversalShow2: PropTypes.bool,
  infoTitleColor: PropTypes.string,
  infoTitleColorOpacity: PropTypes.number,
  pointsColor: PropTypes.string,
  pointsColorOpacity: PropTypes.number,
  rightQuickColor: PropTypes.string,
  rightQuickColorOpacity: PropTypes.number,
  isRightQuickBg: PropTypes.string,
  rightQuickBgColor: PropTypes.string,
  rightQuickBgColorOpacity: PropTypes.number,
  bottomQuickColor: PropTypes.string,
  bottomQuickColorOpacity: PropTypes.number,
  isBottomQuickBg: PropTypes.string,
  bottomQuickBgColor: PropTypes.string,
  bottomQuickBgColorOpacity: PropTypes.number,
  hasBg: PropTypes.string,
  bgType: PropTypes.string,
  bgColor: PropTypes.string,
  bgColorOpacity: PropTypes.number,
  bgImg: PropTypes.shape({ src: PropTypes.string }),
  topMargin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  horizontalOutterMargin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showChevron: PropTypes.bool,
  dispatch: PropTypes.func,
  isWeb: PropTypes.bool,
  isMulPoints: PropTypes.bool,
  pointAccountsInfo: PropTypes.arrayOf(
    PropTypes.shape({
      pointAccountTypeCode: PropTypes.string,
      pointAccountTypeName: PropTypes.string,
      usablePointDisplay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  dxpToken: PropTypes.shape({
    colorBackgroundDark2: PropTypes.string,
    colorTextInverse: PropTypes.string,
    colorBackgroundStandard: PropTypes.string,
  }),
};

export default connect(({ pointShop, index }) => ({
  ...pointShop,
  dxpToken: index.dxpToken,
  isWeb: index.isWeb,
  isMulPoints: index.isMulPoints,
}))(InformationBar);
